import React from 'react'

import { Helmet } from 'react-helmet'

import './not-found.css'

const NotFound = (props) => {
  return (
    <div className="not-found-container1">
      <Helmet>
        <title>404 — Страница не найдена | Arcobo</title>
        <meta name="robots" content="noindex, follow" />
        <meta
          name="description"
          content="Запрошенная страница не найдена. Вернитесь на главную страницу Arcobo."
        />
        <link rel="canonical" href="https://arcobo.tech/404" />
      </Helmet>
      <h3>Упс! Страница не найдена</h3>
      <div className="not-found-container2">
        <h1 className="not-found-text2">404</h1>
      </div>
      <div className="not-found-container3">
        <h2 className="not-found-text3">
          К сожалению, запрошенная страница не существует
        </h2>
      </div>
    </div>
  )
}

export default NotFound
